<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.375 9.375L20.3125 6.25M20.3125 13.0759V16.9821C20.3125 18.0285 19.6188 18.9482 18.6126 19.2357L17.2376 19.6285C16.038 19.9713 14.8438 19.0705 14.8438 17.8228C14.8438 16.9843 15.3996 16.2474 16.2058 16.0171L18.6126 15.3294C19.6188 15.0419 20.3125 14.1223 20.3125 13.0759ZM20.3125 13.0759V2.34375L9.375 5.46875V16.2009M9.375 16.2009V20.1071C9.375 21.1535 8.6813 22.0732 7.67513 22.3607L6.30015 22.7535C5.10046 23.0963 3.90625 22.1955 3.90625 20.9478C3.90625 20.1093 4.46209 19.3724 5.26831 19.1421L7.67513 18.4544C8.6813 18.1669 9.375 17.2473 9.375 16.2009Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMusic',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
